<style lang="less">
@import "./poster.less";
</style>
<template>
  <div class="post_main_r">
    <div class="posterimg_outside" @click="uploadModal = true">
      <div class="poster-btn-bar" v-show="!posterImg">
        <div class="pic">
          <span></span>
        </div>
        <div class="add-txt">添加封面图</div>
        <div class="note-mess">
          一张漂亮的封面图可以吸引更多用户浏览，同时
          <br />可以增加传播效果
        </div>
      </div>
      <img v-show="posterImg" class="posterImg_pic" :src="posterImgSrc" />
    </div>
    <div class="poster-btn-port">
      <p class="btn-change" @click="uploadModal = true" v-show="posterImg">
        <span>更换封面图</span>
      </p>
      <p class="poster-size">建议尺寸：{{size}}，图片小于{{maxSize}}M</p>
    </div>

    <!-- 海报选择的modal -->
    <WtDataModal :show="uploadModal" :styles="{width:'730px'}">
      <div slot="body">
        <div class="topUp_outside">
          <img src="../../assets/images/help_icon_jia.png" />
          <p>
            <strong>请从电脑上传图片</strong>
            <span>图片尺寸为：{{size}}，图片小于2M</span>
          </p>
          <div class="getPicfileOutK">
            <label for="inputImage">
              <input
                type="file"
                ref="referenceUpload"
                name="file"
                id="inputImage"
                title="上传图片"
                @change="inputImagechange"
                accept="image"
              />
            </label>
          </div>
        </div>
        <div class="tc_picList">
          <p class="posterKutit">从海报模板库选择</p>
          <div class="posterKu_main">
            <a
              href="javascript:void(0)"
              @click="tempIndex=key"
              v-for="(item, key) in tempimages"
              :class="{thisOver:tempIndex==key}"
              :key="key"
            >
              <img :src="item.path" :id="item.id" />
              <i></i>
            </a>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="uploadModal = false">取 消</el-button>
        <el-button type="primary" @click="make">确 定</el-button>
      </div>
    </WtDataModal>
    <WtDataModal :show="cropperModal"  :styles="{width:'730px'}">
      <div slot="body">
        <div class="img-container">
          <img
            src="../../assets/images/yin_480.gif"
            :id="imgid"
            class="cropper-hidden"
            accept="image"
          />
        </div>
      </div>
      <div slot="footer">
        <el-button @click="cropperModal = false">取 消</el-button>
        <el-button type="primary" @click="cropperCommit" :loading="cropperCommitLoading">确 定</el-button>
      </div>
    </WtDataModal>
  </div>
</template>

<script>
import Cropper from "cropperjs";
import "./cropper.min.css";
export default {
  name: "Poster",
  props: {
    imgid: {
      type: String,
      default: "cropimg"
    },
    size: {
      type: String,
      default: "900*525"
    },
    aspectRatioWidth: {
      type: Number,
      default: 16
    },
    aspectRatioHight: {
      type: Number,
      default: 9
    },
    maxSize: {
      type: Number,
      default: 2
    },
    picPath: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      coverid: 0, //默认的封面id
      cropperCommitLoading: false,
      cropper: {},
      croppable: false,
      posterImg: false,
      posterImgSrc: "",
      tempIndex: -1,
      tempimages: [
        {
          path:
            "https://img-qn.hudongba.com/static_v4/images/post/poster_image_yundong_04.jpg@!poster_image_preview",
          dataPath:
            "https://img-qn.hudongba.com/static_v4/images/post/poster_image_yundong_08.jpg",
          id: 575
        },
        {
          path:
            "https://img-qn.hudongba.com/static_v4/images/post/poster_image_yundong_08.jpg@!poster_image_preview",
          dataPath:
            "https://img-qn.hudongba.com/static_v4/images/post/poster_image_yundong_10.jpg",
          id: 576
        },
        {
          path:
            "https://img-qn.hudongba.com/static_v4/images/post/poster_image_yundong_08.jpg@!poster_image_preview",
          dataPath:
            "https://img-qn.hudongba.com/static_v4/images/post/poster_image_yundong_11.jpg",
          id: 577
        }
      ],
      uploadModal: false,
      cropperModal: false,
      type: "",
      imgCropperData: {
        accept: "image/gif, image/jpeg, image/png, image/jpg"
      }
    };
  },
  methods: {
    //选择了默认封面图片
    make() {
      this.posterImg = true;
      this.uploadModal = false;
      this.posterImgSrc = this.tempimages[this.tempIndex]["dataPath"];
      this.$emit("itemClick", this.tempimages[this.tempIndex]["path"]);
    },
    inputImagechange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      let type = files[0].type; //文件的类型，判断是否是图片
      let size = files[0].size; //文件的大小，判断图片的大小
      if (this.imgCropperData.accept.indexOf(type) == -1) {
        this.$notify.error({
          title: '错误提示',
          message: '只支持图片上传，请打开正确的图片'
        });
        return false;
      }
      if (size > this.maxSize * 1048576) {
        this.$notify.error({
          title: '错误提示',
          message: "请选择" + this.maxSize + "M以内的图片！"
        });
        return false;
      }
      this.type = type;
      let picValue = files[0];
      let url = this.getObjectURL(picValue);
      //每次替换图片要重新得到新的url
      if (this.cropper) {
        this.cropper.replace(url);
      }
      this.uploadModal = false;
      this.cropperModal = true;
      this.$refs.referenceUpload.value = null; //解决vue 下 input[type='file'] change事件无法上传相同文件的问题
    },
    cropperCommit() {
      if (!this.croppable) {
        return;
      }
      // //转成base64画布，并压缩质量在80%
      let croppedCanvas = this.cropper.getCroppedCanvas();
      let headerImage = croppedCanvas.toDataURL(this.type, 0.8);
      this.cropperCommitLoading = true;
      this.$db
        .post(this.$db.config.upload.uploadActivityBase64, {
          file: headerImage
        })
        .then(resp => {
          this.coverid = resp.data.id;
          this.posterImg = true;
          this.posterImgSrc = resp.data.path;
          this.cropperModal = false;
          this.cropperCommitLoading = false;
        });
    },
    //创建url路径
    getObjectURL(file) {
      var url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    }
  },
  mounted() {
    this.$nextTick(() => {
      let self = this;
      let img = document.getElementById(this.imgid);
      self.cropper = new Cropper(img, {
        aspectRatio: self.aspectRatioWidth / self.aspectRatioHight, //裁剪框的宽高比，在默认的时候，可以随意改变裁剪框的大小
        autoCropArea: 0.9, //裁剪框显示的大小，默认0.8
        dragMode: "move",
        dragCrop: false,
        restore: false,
        center: false,
        highlight: false,
        cropBoxMovable: false, //是否通过拖拽来移动剪裁框
        cropBoxResizable: false, //是否允许拖动 改变裁剪框大小
        toggleDragModeOnDblclick: false, //当点击两次时可以在“crop”和“move”之间切换拖拽模式
        minContainerWidth: 690, //容器的最小宽度
        minContainerHeight: 480, //容器的最小高度
        ready: function() {
          self.croppable = true;
        }
      });
    });
    if (this.picPath) {
      this.posterImg = true;
      this.posterImgSrc = this.picPath;
    }
  },
  watch: {
    coverid(val) {
      //语糖法，这样子会直接返回给到父级的 v-model
      this.$emit("input", val);
    },
    picPath(val) {
      if (val) {
        this.posterImg = true;
        this.posterImgSrc = val;
      } else {
        this.posterImg = false;
        this.posterImgSrc = "";
        this.$emit("input", 0);
      }
    }
  }
};
</script>


<style scoped>
.post_main_r {
  height: 205px;
  width: 100%;
  float: left;
  position: relative;
}
.posterimg_outside {
  width: 210px;
  height: 123px;
  background: url(../../assets/images/posterImg.png) no-repeat 100% 100%;
  float: left;
}
.posterimg_outside {
  width: 348px;
  height: 202px;
  border: 1px solid #d2d6df;
  background: none;
}
.posterimg_outside .poster-btn-bar {
  width: 348px;
  height: 160px;
  background: url(../../assets/images/post-poster-gray.png) no-repeat center;
  cursor: pointer;
  padding-top: 41px;
}
.posterimg_outside .poster-btn-bar .pic {
  width: 100%;
  height: 47px;
  text-align: center;
}
.posterimg_outside .poster-btn-bar .pic span {
  display: inline-block;
  width: 50px;
  height: 47px;
  background: url(../../assets/images/post-party-icon-group.png) no-repeat 0 -150px;
}
.posterimg_outside .poster-btn-bar .add-txt {
  color: #0099e9;
  text-align: center;
}
.posterimg_outside .poster-btn-bar .note-mess {
  text-align: center;
  line-height: 23px;
  color: #8d95a4;
}
.poster-btn-port {
  display: inline-block;
  float: left;
  margin: 140px 0 0 8px;
}

.poster-btn-port p {
  text-align: left;
  color: #65717f;
}
.k_time_ge {
  width: 39px;
  border: none;
  margin: 0;
  text-align: left;
  padding: 0px 13px;
}
.post-period-more-list {
  overflow: visible;
  width: 100%;
}

.post-period-more-list .post-period-main {
  height: auto;
  overflow: visible;
}

.post-period-more-list .post-period-main {
  border: 1px solid #d5d9e1;
  background-color: #fff;
}

.post-period-ul {
  margin-top: -1px;
}
.post-period-main-single .post-period-ul .post-period-li {
  border: 0;
}
.post-period-itembar {
  background-color: #fff;
}
.post-period-itembar .post-period-item-top {
  background-color: #edeeef;
  color: #65717f;
}

.post-period-itembar .post-period-item-top {
  width: auto;
  height: 48px;
  border: 0;
  background: none;
  color: #65717f;
  line-height: 38px;
  border-bottom: 1px solid #d5d9e1;
}
.post-period-itembar .post-period-item-top .item-top-name {
  padding-left: 55px;
  width: 303px;
  margin-left: 0;
}
.post-period-itembar .post-period-item-top .item-top-price {
  width: 114px;
  border-left: 1px solid #d2d6df;
  border-right: 1px solid #d2d6df;
}
.post-period-itembar .post-period-item-top .item-top-limit {
  width: 128px;
  border-right: 1px solid #d2d6df;
}

.post-period-itembar .post-period-item-top span {
  display: inline-block;
  float: left;
  text-align: center;
  line-height: 20px;
  margin-top: 14px;
}
.post-period-itembar .post-period-item-top .item-top-set {
  width: 138px;
}

.post-period-itembar .post-period-item-top span {
  display: inline-block;
  float: left;
  text-align: center;
  line-height: 20px;
  margin-top: 14px;
}
.post-period-itembar .post-period-item-group:first-child {
  border: 0;
}
.post-period-itembar .post-period-item-group .item-drag-top {
  min-height: 78px;
  position: relative;
}
.post-period-itembar .post-period-item-group .item-drag-top .item-drag-icon {
  display: inline-block;
  width: 64px;
  height: 58px;
  float: left;
  margin: 0;
  background: none;
  cursor: move;
}
.post-period-item-group .item-group-k-name {
  width: 160px;
  height: 28px;
  line-height: 28px;
  text-indent: 8px;
  float: left;
  margin: 15px 0 0 5px;
  text-align: left;
  border: 1px solid #d5d9e1;
}
.post-period-itembar .post-period-item-group .item-group-k-price {
  width: 94px;
  height: 38px;
  line-height: 38px;
  margin: 19px 0 0 19px;
  background-color: #fff;
  text-align: center;
  overflow: hidden;
}
.post-period-itembar
  .post-period-item-group
  .item-group-k-price
  .item-group-k-price-input {
  display: inline-block;
  width: 94px;
  height: 38px;
  line-height: 38px;
  margin-left: -25px;
  background-color: #fff;
  text-align: center;
}
.post-period-itembar .post-period-item-group .item-group-k-limit {
  width: 108px;
  height: 38px;
  line-height: 38px;
  margin: 19px 0 0 0;
  background-color: #fff;
  text-align: center;
  overflow: hidden;
}
.post-period-itembar .post-period-item-group .item-group-k-name {
  width: 283px;
  height: 38px;
  line-height: 38px;
  margin: 19px 0 0 0;
  background-color: #fff;
  text-align: center;
}
.poster-btn-port p.btn-change span {
  color: #0099e9;
  cursor: pointer;
}
.posterimg_outside .posterImg_pic {
  width: 345px;
  height: 200px;
}
.img-container {
  width: 690px;
  height: 480px;
}
.cropper-hidden {
  display: none !important;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/poster/poster.vue